import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getPublicConfig } from '../../reducers';
import './_styles_/AuctionCalendarLink.css';

function AuctionCalendarLink() {
    const { auctionCalendar } = useSelector(getPublicConfig);
    return (auctionCalendar && auctionCalendar.text && auctionCalendar.url)
        ? (
            <a href={auctionCalendar.url} target="_blank" rel="noreferrer" className="auction-calendar-link">
                <span className="auction-calendar-link--text">{auctionCalendar.text}</span> <FontAwesomeIcon icon="external-link-alt" size="sm" />
            </a>
        )
        : null;
}

export default AuctionCalendarLink;
